export default __webpack_public_path__ + "static/media/3.ff994233.png";